import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { CustomHttp } from "../../../common/customHttp.service";
import { ApiUrl } from "../../../common/apiUrls";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MainAppComponent } from "../../../layout/layout.component";
import {
  DigitalSignatureModel,
  DigitalSignatureCategoryModel,
} from "../../../common/viewModels/Admin/DigitalSignatureModel";
import "rxjs/add/operator/map";
declare var $: any;

@Component({
  selector: "app-digitalsignatureslist",
  templateUrl: "./digitalsignatureslist.component.html",
  styleUrls: ["./digitalsignatureslist.component.css"],
})
export class DigitalsignatureslistComponent implements OnInit {
  lstDigitalSignatures: DigitalSignatureModel[];
  isNoRecords: boolean = true;
  mainComponent: any;
  categories: DigitalSignatureCategoryModel[];

  // Form and modal properties
  digitalSignatureForm: FormGroup;
  isEdit: boolean = false;
  isSubmitted: boolean = false;
  editingSignatureId: number;
  IsSignatureValid: boolean = true;
  baseUrl: string;
  @ViewChild("fileInput") fileInput: ElementRef;

  viewDisplayName: string;
  viewImgBinary: string;

  constructor(
    private _formBuilder: FormBuilder,
    private _http: CustomHttp,
    private _appUrl: ApiUrl,
    private _mApp: MainAppComponent,
    private _toastrService: ToastrService,
  ) {
    this.mainComponent = _mApp;
    this.baseUrl = this._appUrl.baseUrl;
  }

  ngOnInit() {
    this.CreateForm();
    this.GetFileCategorys();
    this.GetDigitalSignatures();
  }

  CreateForm() {
    this.digitalSignatureForm = this._formBuilder.group({
      Name: ["", Validators.required],
      CategoryId: [null, Validators.required],
      FileName: [""],
      ImgBinary: ["", this.isEdit ? [] : [Validators.required]],
    });
  }

  GetFileCategorys() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetFileCategorys).subscribe(
      (data) => {
        this._mApp.HideLoader();
        if (data.json().Result != null) {
          this.categories = data.json().Result;
        }
      },
      (error) => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, "");
        this.isNoRecords = true;
      },
    );
  }

  GetDigitalSignatures() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetDigitalSignaturesList).subscribe(
      (data) => {
        this._mApp.HideLoader();
        var res = data.json();
        if (res && res.Result && res.Result.length > 0) {
          this.lstDigitalSignatures = res.Result;
          this.isNoRecords = false;
        } else {
          this.lstDigitalSignatures = [];
          this.isNoRecords = true;
        }
      },
      (error) => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, "");
        this.isNoRecords = true;
      },
    );
  }

  OpenAddModal() {
    this.isEdit = false;
    this.isSubmitted = false;
    this.IsSignatureValid = false;

    // Recreate form with proper validators for Add mode
    this.digitalSignatureForm = this._formBuilder.group({
      Name: ["", Validators.required],
      CategoryId: [null, Validators.required],
      FileName: [""],
      ImgBinary: ["", Validators.required],
    });

    if (this.fileInput) {
      this.fileInput.nativeElement.value = "";
    }
    $("#addEditSignatureModal").modal("show");
  }

  OpenEditModal(mediaFileId: number) {
    this.isEdit = true;
    this.isSubmitted = false;
    this.editingSignatureId = mediaFileId;
    this.digitalSignatureForm.get("ImgBinary").clearAsyncValidators();
    this.digitalSignatureForm.get("ImgBinary").setValidators(null);
    this.digitalSignatureForm.get("ImgBinary").updateValueAndValidity();
    if (this.fileInput) {
      this.fileInput.nativeElement.value = "";
    }

    this._mApp.ShowLoader();

    this._http.get(this._appUrl.GetMediaFileById + mediaFileId).subscribe(
      (data) => {
        this._mApp.HideLoader();
        const res = data.json();
        if (res && res.Result != null) {
          this.digitalSignatureForm.patchValue({
            Name: res.Result.DisplayName,
            CategoryId: res.Result.MediaFileCategoryTypeId,
          });

          this.IsSignatureValid = true;

          $("#addEditSignatureModal").modal("show");
        }
      },
      (error) => {
        this._mApp.HideLoader();
        this._toastrService.error(
          (error && error.error && error.error.Result) || "Failed to load data",
        );
      },
    );
  }

  OpenViewModal(mediaFileId: number) {
    this._mApp.ShowLoader();

    this._http.get(this._appUrl.GetMediaFileById + mediaFileId).subscribe(
      (data) => {
        this._mApp.HideLoader();
        const res = data.json();
        if (res && res.Result != null) {
          this.viewDisplayName = res.Result.DisplayName;
          this.viewImgBinary = res.Result.ImgBinary;

          $("#viewSignatureModal").modal("show");
        }
      },
      (error) => {
        this._mApp.HideLoader();
        this._toastrService.error(
          (error && error.error && error.error.Result) || "Failed to load data",
        );
      },
    );
  }

  uploadImage(event: any) {
    const file = event.target.files[0];

    if (file) {
      const ext = file.name.split(".").pop();
      const extLower = ext ? ext.toLowerCase() : "";

      if (["jpeg", "png", "jpg"].includes(extLower)) {
        const reader = new FileReader();

        reader.onload = () => {
          const base64 = reader.result as string;
          this.digitalSignatureForm.patchValue({
            FileName: file.name,
            ImgBinary: base64,
          });
        };

        reader.readAsDataURL(file);
      } else {
        if (this.fileInput) {
          this.fileInput.nativeElement.value = "";
        }
        this._toastrService.error(
          "Invalid file type. Please upload JPEG, PNG, or JPG images only.",
        );
      }
    }
  }

  OnSubmit() {
    this.isSubmitted = true;
    if (this.digitalSignatureForm.valid) {
      const model = {
        MediaFileId: this.isEdit ? this.editingSignatureId : null,
        MediaFileCategoryTypeId: this.digitalSignatureForm.value.CategoryId,
        DisplayName: this.digitalSignatureForm.value.Name,
        FileName: this.digitalSignatureForm.value.FileName || "",
        ImgBinary: this.digitalSignatureForm.value.ImgBinary || "",
      };

      this._mApp.ShowLoader();
      this._http.post(this._appUrl.upsertSignature, model).subscribe(
        (data) => {
          this._mApp.HideLoader();
          this._toastrService.success(
            this.isEdit
              ? "Digital Signature updated successfully"
              : "Digital Signature created successfully",
            "",
          );
          $("#addEditSignatureModal").modal("hide");
          this.GetDigitalSignatures();
        },
        (error) => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, "");
        },
      );
    }
  }

  OnCancel() {
    this.isSubmitted = false;
    this.isEdit = false;
    this.digitalSignatureForm.reset();
    if (this.fileInput) {
      this.fileInput.nativeElement.value = "";
    }
    $("#addEditSignatureModal").modal("hide");
  }

  DeleteMediaFile(mediaFileId: number) {
    this.editingSignatureId = mediaFileId;
    $("#deleteSignatureModal").modal("show");
  }

  DeleteMediaFileById() {
    this._mApp.ShowLoader();

    this._http
      .get(this._appUrl.DeleteMediaFile + this.editingSignatureId)
      .subscribe(
        (data) => {
          this._mApp.HideLoader();
          const res = data.json();
          if (res && res.Result != null) {
            this._toastrService.success(res.Result.message, "");
            $("#deleteSignatureModal").modal("hide");
            this.GetDigitalSignatures();
          } else {
            this._toastrService.error(res.Result.message, "");
          }
        },
        (error) => {
          this._mApp.HideLoader();

          this._toastrService.error(
            (error && error.error && error.error.Result) || "Delete failed",
            "",
          );
        },
      );
  }
}
